module.exports = __webpack_public_path__ + "img/1.e54fbb28.png";